<script>
import { onMount } from 'svelte';
import { storyblokEditable, StoryblokComponent, renderRichText, useStoryblokApi } from "@storyblok/svelte";
import closeImg from '$lib/images/close.svg';
import { transform, getHref, mySchema } from '$lib/storyblok';
import { Spinner } from 'flowbite-svelte';
import { languageTag } from "$lib/../paraglide/runtime.js"

let lang = languageTag();

export let blok;
export let published_at = '';

let inhoud = blok.inhoud;

let player = null;
let showVideoPopup = false;

$: pageIntro = renderRichText(blok.intro, { schema: mySchema });

function togglePopup() {
    sessionStorage.setItem("popupclosed", "true");
    showVideoPopup = !showVideoPopup;

    if(blok.video.type == "youtube") {
        if(showVideoPopup) {
            if(!player) {
                player = new YT.Player(blok.video.id, {
                  playerVars: {
                    autoplay: 1, // Automatisch afspelen
                    mute: 1,     // Geluid uitzetten
                  },
                events: {
                  'onReady': onPlayerReady
                }
                });
            }
        } else {
            player.pauseVideo();
        }
    } else if(blok.video.type == "vimeo") {
        if(showVideoPopup) {
            if(!player) {
                player = new Vimeo.Player(blok.video.id);
                player.setVolume(0);
                player.play();
            }
        } else {
            player.pause();
        }
    }
}

function onPlayerReady(event) {
  event.target.mute();   // Zet het geluid uit (optioneel, maar redundantie kan handig zijn)
  event.target.playVideo(); // Speel de video af
}

onMount(() => {
  console.log(blok.video);
  if(!sessionStorage.getItem("popupclosed")) {
    togglePopup();
  }
});  

</script>

<svelte:head>
    {#if blok.video}
      {#if blok.video.type == "youtube"}
          <script src="https://www.youtube.com/iframe_api"></script>
      {:else if blok.video.type == "vimeo"}
          <script src="https://player.vimeo.com/api/player.js"></script>
      {/if}
    {/if}
</svelte:head>

{#key blok}
  <div use:storyblokEditable={blok} class="homepage-header">
    <div class="header-holder">
      <div class="image-holder">
          <img src={transform(blok.afbeelding.filename, '1920x590', 80)} alt={blok.afbeelding.alt} />
      </div>

      <div class="container">
        <div class="intro-holder">
          <div class="grid md:grid-cols-5 md:gap-[30px] sm:gap-[15px] gap-[10px]">
            <div class="col-span-2">
              <h1 class="h1">{blok.titel}</h1>
            </div>
            <div class="col-span-3">
              <div class="page-intro">{@html pageIntro}</div>

              {#if blok.doorverwijzing_tekst && blok.doorverwijzing.cached_url }
                <div class="button-holder">
                  <a href={getHref(blok.doorverwijzing)} class="button">
                    {blok.doorverwijzing_tekst}
                    <svg width="9px" height="15px" viewBox="0 0 9 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Button---Magenta-Copy" transform="translate(-124, -17)" stroke="#FFFFFF" stroke-width="2"><g id="Group" transform="translate(117, 14)"><polyline id="Path" points="8.8 4.4 14.9875 10.5875 8.8 16.775"></polyline></g></g></g></svg>
                  </a>
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {#if blok.video}
    <div class="popup-background" class:show={showVideoPopup}>
        <div class="video-popup" >
            <img class="close-img" src={closeImg} alt="" quality="100" on:click={togglePopup}/>
            {@html blok.video.iFrame}
        </div>
    </div>
  {/if}

  <div class="content" id="content">
    {#each inhoud as blok, index}
      <StoryblokComponent {blok} countIndex={index} />
    {/each}
  </div>
{/key}
<style lang="postcss">
   .header-holder .image-holder {
    width: calc(100% - 80px);
    max-width: 100%;
    margin: 0 auto;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .header-holder .intro-holder {
    margin: 75px 0;
  }

  .popup-background {
        opacity: 0;
        visibility: hidden;
        transition: all 400ms;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        padding: 40px;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 100;

        &.show {
            opacity: 1;
            visibility: visible;
        }
    }

    .video-popup {
        max-width: calc((16/9) * (100vh - 80px));
        display: block;
        margin: auto;
        position: relative;
    }

    .close-img {
        position: absolute;
        right: -25px;
        top: -25px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        transition: all 500ms;

        &:hover {
            transform: rotate(180deg);
        }  
    }


  @media only screen and (max-width: 960px) {
    .header-holder .intro-holder {
      margin: 50px 0;
    }
  }

  @media only screen and (max-width: 767px) {
    .header-holder .image-holder {
      width: calc(100% - 40px);
      max-width: calc(100% - 40px);
    }

    .header-holder .intro-holder {
      margin: 30px 0 20px;
    }
  }
</style>